// @flow

import type { State } from "@store/reducers";
import type { Notification } from "@modules/reporting/reducer/notifications/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export type GetMyNotifications = (state: State) => Notification[];
export type GetMyNotificationsPage = (state: State) => number | null;

export const getMyNotifications = (state: State): Notification[] =>
  state.reporting.notifications.myNotifications.content || [];

export const getMyNotificationsPagination = (state: State): PaginationExtendedType =>
  getPagination(state.reporting.notifications.myNotifications);

export const getMyNotificationsPage = (state: State): number | null =>
  getMyNotificationsPagination(state).pageNumber;

export const selectMyNotificationsSearch = (state: State): string => {
  return state.reporting.notifications.notificationsSearch;
};
